export default __webpack_public_path__ + "static/media/FAQ.ad4e0ffb.png";